import { render, staticRenderFns } from "./FileBotResponse.vue?vue&type=template&id=64ed4de6&scoped=true"
import script from "./FileBotResponse.vue?vue&type=script&lang=js"
export * from "./FileBotResponse.vue?vue&type=script&lang=js"
import style0 from "./FileBotResponse.vue?vue&type=style&index=0&id=64ed4de6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ed4de6",
  null
  
)

export default component.exports